<template>
  <div class="cases-wrapper" dir="ltr">
    <swiper
      :effect="'coverflow'"
      :centered-slides="true"
      :slides-per-view="'auto'"
      :coverflow-effect="{
        rotate: 0,
        stretch: -200,
        depth: 180,
        modifier: 1,
        slideShadows: false,
      }"
      :pagination="{
        type: 'custom',
      }"
      :modules="modules"
      class="mySwiper"
      @slide-change="slideChange"
      @swiper="onSwiper"
    >
      <swiper-slide
        v-for="(item, index) in objects"
        :key="index"
        class="mySwiperSlide"
        :class="{'active-slide': index === activeIndex}"
      >
        <img :src="item.src" alt="" />
        <div
          v-show="index === activeIndex"
          class="info"
          :class="{rightDir: rightDir}"
        >
          <div class="info-title">
            {{ $t(item.title) }}
          </div>
          <div class="info-subtitle">
            {{ $t(item.subtitle) }}
          </div>
          <div class="info-time">
            {{ $t(item.created) }} <span>{{ $t(item.time) }}</span>
          </div>
        </div>
      </swiper-slide>

      <div
        class="prev"
        :class="{'block-disable': activeIndex === 0}"
        @click="swiperInstance.slidePrev()"
      />
      <div
        class="next"
        :class="{'block-disable': activeIndex === objects.length - 1}"
        @click="swiperInstance.slideNext()"
      />
    </swiper>
    <div class="dots">
      <div
        v-for="(_, idx) in objects"
        :key="idx"
        class="dot"
        :class="{active: idx === activeIndex}"
        @click="swiperInstance.slideTo(idx)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {Swiper, SwiperSlide} from 'swiper/vue';
import {EffectCoverflow, Pagination} from 'swiper';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import {tempLang} from '~/modules/CityScape/helpers/languages';
import {useRuntimeConfig} from '#imports';
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const rightDir = computed(() => useCookie('lang').value === 'ar');

const activeIndex = ref(0);
const swiperInstance = ref();

const objects = ref<
  Array<{
    src: string;
    title: keyof typeof tempLang;
    subtitle: keyof typeof tempLang;
    created: keyof typeof tempLang;
    time: keyof typeof tempLang;
  }>
>([
  {
    src: `${staticUrl}/images/cityscapeImages-1.webp`,
    title: 'firstSlideTitle',
    subtitle: 'firstSlideDesc',
    created: 'createdIn',
    time: 'firstSlideTime',
  },
  {
    src: `${staticUrl}/images/cityscapeImages-2.webp`,
    title: 'secondSlideTitle',
    subtitle: 'secondSlideDesc',
    created: 'createdIn',
    time: 'secondSlideTime',
  },
  {
    src: `${staticUrl}/images/cityscapeImages-3.webp`,
    title: 'thirdSlideTitle',
    subtitle: 'thirdSlideDesc',
    created: 'createdIn',
    time: 'thirdSlideTime',
  },
  {
    src: `${staticUrl}/images/cityscapeImages-4.webp`,
    title: 'fourSlideTitle',
    subtitle: 'fourSlideDesc',
    created: 'createdIn',
    time: 'fourSlideTime',
  },
  {
    src: `${staticUrl}/images/cityscapeImages-5.webp`,
    title: 'fiveSlideTitle',
    subtitle: 'fiveSlideDesc',
    created: 'createdIn',
    time: 'fiveSlideTime',
  },
  {
    src: `${staticUrl}/images/cityscapeImages-6.webp`,
    title: 'sixSlideTitle',
    subtitle: 'sixSlideDesc',
    created: 'createdIn',
    time: 'sixSlideTime',
  },
  {
    src: `${staticUrl}/images/cityscapeImages-7.webp`,
    title: 'sevenSlideTitle',
    subtitle: 'sevenSlideDesc',
    created: 'createdIn',
    time: 'sevenSlideTime',
  },
]);

function onSwiper(instance: any) {
  swiperInstance.value = instance;
}

function slideChange(event: any) {
  activeIndex.value = event.activeIndex;
}

const modules = [EffectCoverflow, Pagination];
</script>

<style lang="scss" scoped>
::selection {
  background: #00deba; /* Safari */
}

::-moz-selection {
  background: #00deba; /* Firefox */
}

.cases-wrapper {
  position: relative;
  margin: 0 auto;
  width: 100%;
  user-select: none;
  // display: flex;
  // flex-direction: column;

  .dots {
    // position: absolute;
    // left: 50%;
    // bottom: -36px;
    // transform: translateX(-50%);
    // margin: 0 auto;
    margin-top: 24px;
    height: 12px;
    display: flex;
    justify-content: center;
    gap: 8px;
    z-index: 100;

    .dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #b2c0cd;
      cursor: pointer;

      &.active {
        background: #00deba;
      }
    }
  }

  .mySwiper {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: visible;

    .prev {
      position: absolute;
      left: -36%;
      top: 6%;
      height: 550px;
      width: 300px;
      background: transparent;
      cursor: pointer;
      z-index: 100;
    }

    .block-disable {
      cursor: default;
      pointer-events: none;
    }

    .next {
      position: absolute;
      right: -36%;
      top: 6%;
      height: 550px;
      width: 300px;
      background: transparent;
      cursor: pointer;
      z-index: 100;
    }

    .mySwiperSlide {
      position: relative;
      display: block;
      //height: 671px;
      //width: 1128px;
      opacity: 0.3;

      &.active-slide {
        position: relative;
        opacity: 1;

        .info {
          position: absolute;
          //bottom: 36px;
          bottom: 0;
          left: 0;
          width: 100%;
          min-height: 174px;
          padding: 32px;
          background: linear-gradient(
            180deg,
            rgba(6, 44, 73, 0.3) 16.47%,
            rgba(6, 44, 73, 0.85) 89.07%
          );
          border-bottom-left-radius: 32px;
          border-bottom-right-radius: 32px;
          display: flex;
          flex-direction: column;
          &.rightDir {
            align-items: flex-end;
            text-align: right;
          }

          &-title {
            margin-bottom: 16px;
            color: var(--white-theme-white-000, #fff);
            font-family: Segoe UI;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            letter-spacing: 0.72px;
          }

          &-subtitle {
            width: 386px;
            margin-bottom: 8px;
            color: var(--white-theme-white-000, #fff);
            font-family: Segoe UI;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%; /* 22.4px */
            letter-spacing: 0.48px;
          }

          &-time {
            color: var(--white-theme-white-000, #fff);
            font-family: Segoe UI;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%; /* 22.4px */
            letter-spacing: 0.48px;

            & > span {
              color: var(--white-theme-white-000, #fff);
              font-family: Segoe UI;
              font-size: 24px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
              letter-spacing: 0.72px;
            }
          }
        }
      }

      img {
        display: block;
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .info {
    padding: 12px !important;
    min-height: auto !important;
    border-bottom-left-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    .info-title {
      font-size: 15px !important;
      margin-bottom: 8px !important;
    }

    .info-subtitle {
      font-size: 15px !important;
      margin-bottom: 8px !important;
      width: 100% !important;
    }

    .info-time {
      font-size: 15px !important;

      span {
        font-size: 15px !important;
      }
    }
  }
  .prev {
    height: 200px !important;
    top: 0 !important;
    display: none !important;
  }
  .next {
    height: 200px !important;
    top: 0 !important;
    display: none !important;
  }
  .cases-wrapper {
    .dots {
      .dot {
        width: 8px;
        height: 8px;
      }
    }
  }
}
</style>
